import React from 'react'
import ContentLoader from 'react-content-loader'

export const TradeInCategoriesSkeleton = () => (
	<ContentLoader
		uniqueKey="trade-in-categories-skeleton"
		speed={2}
		width={438}
		height={40}
		viewBox="0 0 438 40"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb">
		<rect x="0" y="0" rx="20" ry="20" width="438" height="40" />
	</ContentLoader>
)
